<template>
  <div class="el-input-number-or-none-dialog el-input-group__unit">
    <el-input-comma-number
      v-model="numberValue"
      controls-position="right"
      :min="0"
      :max="max"
      :disabled="disabled || checkboxValue"
      @change="onNumberChange"
      @input="onNumberInput"
    />
    <span
      v-if="unit"
      class="input-unit"
      :class="{'is-disabled': checkboxValue}"
    >
      {{ unit }}
    </span>
    <el-checkbox
      v-model="checkboxValue"
      :disabled="disabled"
      @change="onCheckboxChange"
    >
      <p>
        제한없음
      </p>
    </el-checkbox>
  </div>
</template>

<script>
import ElInputCommaNumber from '@/components/element-ui/ElInputCommaNumber';

export default {
  name: 'ElInputNumberOrNoneDialog',
  components: {
    ElInputCommaNumber
  },
  props: {
    value: {},
    max: {
      type: Number,
      default: Infinity
    },
    disabled: {
      default: false
    },
    unit: String,
    noneValue: {}
  },
  data() {
    return {
      checkboxValue: false,
      numberValue: 0
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === this.noneValue) {
          this.numberValue = '';
          return (this.checkboxValue = true);
        }

        this.checkboxValue = false;
        return (this.numberValue = value);
      }
    }
  },
  methods: {
    onNumberChange(value) {
      this.$emit('change', value);
    },
    onNumberInput(value) {
      if (this.checkboxValue) {
        this.$emit('input', this.noneValue);
      } else {
        this.$emit('input', value);
      }
      return;
    },
    onCheckboxChange(value) {
      if (value) {
        this.$emit('input', this.noneValue);
        return this.$emit('change', this.noneValue);
      }

      this.$emit('input', this.numberValue);
      this.$emit('change', this.numberValue);
    }
  }
};
</script>

<style lang="scss">
.el-input-number-or-none-dialog {
  .el-input__inner {
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    letter-spacing: -0.8px;
    color: #9b9b9b;
    font-weight: 300;
  }

  .el-checkbox {
    width: 110px;
    height: 30px;
    padding: 10px 0 0 0;
    display: inline-flex;
    .el-checkbox__input {
      margin: auto 0;
    }

    .el-checkbox__label {
      width: 100%;
      display: flex;
      font-size: 14px;
      font-weight: normal;
      p {
        line-height: 19px;
        margin: auto 0;
      }
    }
  }

  .el-input-number {
    &.is-controls-right {
      .el-input-number__increase,
      .el-input-number__decrease {
        width: 30px;
        height: auto;
        line-height: 24px;
      }
    }
  }
}
</style>
